import { FormikHelpers } from 'formik';
import { enqueueSnackbar } from 'notistack';

import { useFormContext } from 'context/FormContext';
import { useShowError } from 'hooks/useShowError';
import { useFormMutation } from 'mutations/useFormMutation';
import { Revendedor } from 'pages/revendedor/revendedor/types';

export function useMutateRevendedor() {
    const { mutate, isLoading } = useFormMutation();
    const { setContent } = useFormContext();
    const { showError } = useShowError();

    const handleSubmit = (formData: Revendedor, formik: FormikHelpers<Revendedor>) => {
        mutate(
            {
                url: '/gestao/revendedorwrapper',
                idField: 'idRevendedor',
                preventSnack: true,
                formik,
                formData,
            },
            {
                onSuccess: ({ data }: any) => {
                    const newData = data.data;

                    setContent(newData);

                    enqueueSnackbar('Revendedor salvo com sucesso!', { variant: 'success' });
                },
                onError: (error: any) => showError(error, 'Não foi possível salvar o revendedor. Tente novamente'),
            },
        );
    };

    return { handleSubmit, isLoading };
}
